import { Injectable } from '@angular/core';
import { VersionService } from './version';

@Injectable()
export class LocationsService {
  constructor(public versionService: VersionService) {}

  country = this.versionService.country;

  countries = {
    MX: 'Mexico',
    CL: 'Chile',
    PE: 'Peru',
    CO: 'Colombia',
  };

  translations = {
    defaultCityId: {
      MX: 1, // ciudad de méxico
      CL: 10, // santiago
      PE: 16, // lima
      CO: 45, // bogota
    },
    defaultLocation: {
      // Auditorio nacional
      MX: {
        lat: 19.4248097,
        lng: -99.1971143,
      },
      // Palacio de la moneda
      CL: {
        lat: -33.4446518,
        lng: -70.6575146,
      },
      // Larcomar, Miraflores
      PE: {
        lat: -12.1319449,
        lng: -77.0327089,
      },
      // Simón Bolívar Metropolitan Park
      CO: {
        lat: 4.6705513,
        lng: 74.1174916,
      },
    },
    paymentProcessor: {
      MX: 'stripe',
      CL: 'kushki',
      PE: 'kushki',
      CO: 'kushki',
    },
    currencyPrefix: {
      // these are needed since we wanted a format that couldn't be achieved with angular pipes
      MX: '$',
      CL: '$',
      PE: 'S/',
      CO: '$',
    },
    decimalPlaces: {
      MX: 0,
      CL: 0,
      PE: 2,
      CO: 0,
    },
    currencySuffix: {
      MX: '',
      CL: ' CLP',
      PE: '',
      CO: '',
    },
    currencyDecimal: {
      MX: '.',
      CL: ',',
      PE: '.',
      CO: ',',
    },
    thousandsComma: {
      MX: ',',
      CL: '.',
      PE: ',',
      CO: '.',
    },
    studio: {
      MX: 'studio',
      CL: 'centro',
      PE: 'centro',
      CO: 'centro',
    },
    showers: {
      MX: 'Regaderas',
      CL: 'Duchas',
      PE: 'Duchas',
      CO: 'Duchas',
    },
    expiry: {
      MX: 'corte',
      CL: 'vencimiento',
      PE: 'vencimiento',
      CO: 'vencimiento',
    },
    'expiry date': {
      MX: 'Fecha corte',
      CL: 'Fin de ciclo',
      PE: 'Fin de ciclo',
      CO: 'Fin de ciclo',
    },
    get: {
      MX: 'Adquiere',
      CL: 'Obtén',
      PE: 'Obtén',
      CO: 'Obtén',
    },
    pwError: {
      MX: 'Correo inválido o no encontrado en el sistema',
      CL: 'Correo incorrecto',
      PE: 'Correo inválido',
      CO: 'Correo incorrecto',
    },
    area: {
      MX: 'zona',
      CL: 'comuna',
      PE: 'distrito',
      CO: 'municipio',
    },
    city: {
      MX: 'Ciudad',
      CL: 'Ciudad',
      PE: 'Ciudad',
      CO: 'Región',
    },
    bill: {
      MX: 'factura',
      CL: 'boleta',
      PE: 'boleta',
      CO: 'boleta',
    },
    business: {
      MX: 'Razón social (completa)',
      CL: 'Especificar si es persona natural o empresa',
      PE: 'Especificar si es persona natural o empresa',
      CO: 'Especificar si es persona natural o empresa',
    },
    TIN: {
      MX: 'RFC',
      CL: 'RUT',
      PE: 'DNI (persona natural) RUC (empresa)',
      CO: 'RUT',
    },
    MaxPhoneLength: {
      MX: 10,
      CL: 9,
      PE: 9,
      CO: 10,
    },
    invalid: {
      MX: 'inválido',
      CL: 'no válido',
      PE: 'inválido',
      CO: 'no válido',
    },
    pin: {
      MX: 'Número de seguridad',
      CL: 'Código de seguridad',
      PE: 'Código de seguridad',
      CO: 'Código de seguridad',
    },
    noShow: {
      MX: 'no-show',
      CL: 'inasistencia',
      PE: 'inasistencia',
      CO: 'inasistencia',
    },
    refer: {
      MX: 'Referir',
      CL: 'Invitar',
      PE: 'Invitar',
      CO: 'Invitar',
    },
    fpZone: {
      //This are the small areas fitpass uses: FiltersPage
      MX: 'Zona',
      CL: 'Comuna',
      PE: 'Distrito',
      CO: 'Municipio',
    },
    fpMailZone: {
      // This is used when requesting billing by mail: ProfilePage
      MX: 'Delegación',
      CL: 'Comuna',
      PE: 'Distrito',
      CO: 'Municipio',
    },
    infoMail: {
      MX: 'info@fitpass.mx',
      CL: 'info@fitpass.cl',
      PE: 'info@fitpass.pe',
      CO: 'info@fitpass.co',
    },
    url: {
      MX: 'https://www.fitpass.mx/',
      CL: 'https://www.fitpass.cl/',
      PE: 'https://www.fitpass.pe/',
      CO: 'https://www.fitpass.co/',
    },
    'a payment processor': {
      MX: 'un proceso de pagos',
      CL: 'un proceso de pagos',
      PE: 'una plataforma segura',
      CO: 'un proceso de pagos',
    },
    instructor: {
      MX: 'maestro',
      CL: 'maestro',
      PE: 'instructor',
      CO: 'maestro',
    },
    pictureId: {
      MX: 'identificación oficial',
      CL: 'identificación oficial',
      PE: 'identificación con foto o DNI',
      CO: 'identificación oficial',
    },
  };

  translate(toTranslate) {
    return this.translations[toTranslate][this.country];
  }

  getCountry() {
    return this.countries[this.country];
  }

  states: {id:string, name:string}[];

  cities: {}[];

  getCitiesByStateId(stateId) {
    // tslint:disable-next-line: triple-equals
    return this.cities.filter((city: any) => city.state_id == stateId);
  }

  removeStatesAndCities() {
    this.states = null;
    this.cities = null;
  }
}



// WEBPACK FOOTER //
// ./src/services/locations.ts